import { render } from "./Product.vue?vue&type=template&id=0bf0095c&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=0bf0095c&lang=scss&scoped=true"
import "./Product.vue?vue&type=style&index=1&id=0bf0095c&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf0095c"]])

export default __exports__